import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Button,
  Link,
  Grid,
  Row,
  Col,
  Panel,
  Hr,
  Margin,
  Table,
  Text,
} from 'shared/components'
import { admin } from 'routes/route.map'

import { SponsorsFilters } from './components/filters'
import * as styles from './styles'

const SponsorsOverviewComponent = ({ columns, onSearch, loadSponsors }) => (
  <Panel>
    <Text as="h1" size={18} bold>
      Sponsors
    </Text>
    <Margin tb={3}>
      <Hr width="full" />
    </Margin>
    <Margin tb={3}>
      <Grid>
        <Row>
          <Col xs={12} sm={10}>
            <SponsorsFilters debounce={250} onSearch={onSearch} />
          </Col>
          <Col xs={12} sm={2}>
            <div css={styles.controlsWrapper}>
              <Link to={admin.sponsors.add()}>
                <Button plain>
                  <FontAwesomeIcon size="1x" icon="plus-circle" />
                  <Text size={11}>Add sponsor</Text>
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Grid>
    </Margin>
    <Table id="sponsors-table" columns={columns} loadData={loadSponsors} />
  </Panel>
)

SponsorsOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadSponsors: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
}

export default SponsorsOverviewComponent
